<template>
  <div id="app">
<!--    <div class="pdt-btn">-->
<!--      &lt;!&ndash; <div class="print-btn" v-if="dbool && isPdf ==false">-->
<!--        <a class="download" @click="download">下载PDF</a>-->
<!--      </div> &ndash;&gt;-->
<!--    </div>-->
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      dbool: true,
      isPdf: false,
      isReport: false,
      id: [],
      paperTypeDown: 0, //2 心理  3 人格  4 团队   5 潜力
      candIds: [],
    };
  },
  mounted() {
    let candId = this.getUrlParam("candId");
    let token = this.getUrlParam("token");
    if (candId == null) {
      this.candIds.push("tiC2GalSGaGbtySbnDMYGyC2nDI2nDC1"); //为了本地可以测试 haha的
    } else {
      this.candIds.push(candId);
    }
    if (
      location.hash.indexOf("/pdf") > -1 ||
      location.hash.indexOf("/personalitypdf") > -1 ||
      location.hash.indexOf("/teampdf") > -1 ||
      location.hash.indexOf("/behaviorpdf") > -1 || location.hash.indexOf("/personalPdf") > -1 || location.hash.indexOf("/personal") > -1
    ) {
      this.isPdf = true;
    }
    if(token){
      this.$axios.defaults.headers.post['Authorization'] = 'Bearer ' + token
    }
  },
  methods: {
    download() {
      this.dbool = false;
      // this.$store.dispatch("setDownload", true);
      setTimeout(() => {
        window.print();
      }, 200);
    },
    downloadPdf() {
      this.$notify({
        title: "提示",
        message: "报告正在努力生成中，请稍后……",
        type: "success",
        duration: 30000,
      });
      let paperTypeDown = 0;
      if (location.hash.indexOf("home") > -1) {
        paperTypeDown = 2;
      }
      if (location.hash.indexOf("personality") > -1) {
        paperTypeDown = 3;
      }
      if (location.hash.indexOf("team") > -1) {
        paperTypeDown = 4;
      }
      if (location.hash.indexOf("behavior") > -1) {
        paperTypeDown = 5;
      }
      let post = {
        id: this.candIds,
        paperType: paperTypeDown,
      };
      $.post(
        "https://report-demo.acmcoder.com/prj/outputPdfNew.do",
        post,
        function (data) {
          if (data != "") {
            let ids = data;
            window.loadOPN = function () {
              $.post(
                "https://report-demo.acmcoder.com/prj/outputNum.do",
                { id: ids },
                function (data2) {
                  if (data2 == 1) {
                    setTimeout(function () {
                      window.location.href =
                        "https://report-demo.acmcoder.com/prj/outputZipNew.do?id=" +
                        ids +
                        "&prjid=1&prjname=11&paperType=" +
                        paperTypeDown;
                    }, 5000);
                  } else if (data2 == 2) {
                    //失败 没有成功的
                    this.$message.error("下载失败，请联系管理员");
                  } else {
                    //失败
                    setTimeout("window.loadOPN()", 1000);
                  }
                }
              );
            };
            window.loadOPN();
          } else {
          }
        }
      );
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
      var r = window.location.search.substr(1).match(reg); //匹配目标参数
      if (r != null) return unescape(r[2]);
      return null; //返回参数值
    },
  },
};
</script>
<style lang="scss" scoped>
#app {
  width: 800px;
  height: auto;
  margin: 0px auto;
  background-color: white;
  .print-btn {
    position: fixed;
    right: 20px;
    top: 100px;
    .download {
      padding: 40px 20px;
      background: #333;
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue